export enum UserTeamCategory {
    SUPERVISED = 'supervised',
    WATCHED = 'watched',
    MEMBERSHIP = 'membership',
}
